import { Injectable } from '@angular/core';
import { StorageService } from '@app/shared';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';
import { I18nHtmlLangService } from './html-lang.service';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    language$ = new BehaviorSubject<string>('');
    changed$ = new Subject<string>();

    constructor(private translateService: TranslateService, private storageService: StorageService, private i18nHtmlLangService: I18nHtmlLangService) {}

    init() {
        this.translateService.setDefaultLang(environment.defaultLanguage);
        const lang = <string>this.storageService.getItem('language');
        if (lang && environment.supportedLanguages.includes(lang)) {
            this.translateService.use(lang);
            this.language$.next(lang);
            this.changed$.next(this.get());
        } else {
            this.language$.next(this.get());
            this.changed$.next(this.get());
        }
    }

    set(lang: string): void {
        this.translateService.use(lang);
        this.i18nHtmlLangService.setLang(lang);
        this.storageService.setItem('language', lang);
        this.language$.next(lang);
        this.changed$.next(this.get());
    }

    get(): string {
        if (!this.translateService.currentLang) {
            this.translateService.use(environment.defaultLanguage);
        }
        return this.translateService.currentLang;
    }
}
